import { render } from "./TgDatePicker.vue?vue&type=template&id=f3ab0202"
import script from "./TgDatePicker.vue?vue&type=script&lang=js"
export * from "./TgDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__